import Button from "components/form/Button";
import InputField from "components/form/InputField";
import React from "react";

const NotAllowed = ({
  email,
  setEmail,
  handleContinue,
  handleCheckout,
  isLoggedIn,
}: {
  email: string;
  setEmail: (email: string) => void;
  handleContinue: () => void;
  handleCheckout: () => void;
  isLoggedIn?: boolean;
}) => {
  return (
    <div className="max-w-[520px] w-full h-fit p-5">
      <p className="font-medium lg:text-xl text-lg text-txtPrimary">
        You already have a subscription with us{" "}
      </p>
      <p className="lg:text-base text-sm text-txtSecondary pt-3">
        Click continue to manage it.{" "}
      </p>
      <div className="py-10">
        <InputField
          name="Email"
          label="Email"
          className="!pl-[15px] !pr-[15px] !py-2 !text-xs !rounded-[5px] "
          _className="!text-xs !font-bold !leading-normal"
          placeholder="Email address"
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          value={email}
          disabled={!!email}
        />
      </div>
      <Button
        text="Continue"
        className={"!w-full"}
        onClick={() => {
          handleContinue();
        }}
        variant={"variable"}
      />
      <div className="w-full mx-auto grid place-items-center pt-3">
        <p
          className={`w-fit text-center text-blue hover:!text-btnPrimaryHover lg:text-base text-sm font-medium cursor-pointer`}
          onClick={() => {
            handleCheckout();
          }}
        >
          Check out with a different email
        </p>
      </div>
    </div>
  );
};

export default NotAllowed;
